import React from 'react'
import "./medical_equ_data.js"
import "./medical_equ.css"
import banner from "../../Assets/cover.png"
import CoverHero from '../CoverHero.jsx'
import Header from '../../Header/Header.jsx'
import Footer from "../../Footer/Footer.jsx"
import ServiceShowcase from '../ServiceShowCase.jsx'
import CardsContainer from '../CardsContainer.jsx'
import Testimonials from '../../Testimonial/Testimonial.jsx'
import ServicesGrid from '../ServiceGrid.jsx'

import {
  serviceShowcaseData, medical_text, medicalequ_data, cardsh2, cardsh4, settle_title,
  why_settle_data, chooseexcellence_data, medicalequ_equ_testimonials
} from './medical_equ_data.js'
import { useState } from 'react'
import LoginModal from '../../Modals/LoginModal.js'
import { useNavigate } from 'react-router-dom'

const MedicalEqu = () => {
  const navigate = useNavigate();
  return (
    <div>
      <Header />
      <CoverHero image={banner} title="Medical Equipments" />

      <div className="servicesShowCase">
        {serviceShowcaseData.map((service, index) => (
          <ServiceShowcase
            key={index}
            className="medical-equ"
            data={service}
            onServiceClick={() => navigate('/')}
          />
        ))}
      </div>

      <div className="texts-physio">
        <h2>{medical_text.heading}</h2>
        <p>{medical_text.para}</p>
      </div>

      <div className="empowering-you">
        <CardsContainer
          heading={cardsh2}
          subheading={cardsh4}
          services={Object.values(medicalequ_data)}
          className="medical-equ-cardscontainer"
        />
      </div>
      <div className="why-settle">
        <CardsContainer
          heading={settle_title}
          services={Object.values(why_settle_data)}
          className="why-settle-cardscontainer"
        />
      </div>

      <div className="choose-excellence">
        <h2 className="excellence-title">{chooseexcellence_data.title}</h2>
        <div className="excellence-content">
          <div className="blend-container">
            <h3>{chooseexcellence_data.subheading}</h3>
            <p>{chooseexcellence_data.para}</p>
          </div>

          <div className="image-container">
            <img src={chooseexcellence_data.image} alt={chooseexcellence_data.title} />
          </div>
        </div>
      </div>

      <div className="excellence-testimonials-container">
        <Testimonials
          data={medicalequ_equ_testimonials}
          textKey="desc"
          imgKey="userimg"
          nameKey="username"
          className="excellence-testimonials"
        />
      </div>
      <ServicesGrid title="Check Our Other Services" exclude="Medical Equipment" />
      <Footer />
    </div>

  )
}

export default MedicalEqu